<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush "
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template slot="columns">
          <th>{{variables.get('nameSurname')}}</th>
          <th>{{variables.get('firstFollowDate')}}</th>
          <th>{{variables.get('accountStatus')}}</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img alt="Image placeholder" :src="row.img" />
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.title}}</span>
              </div>
            </div>
          </th>
          <td class="first_follow_date">{{row.first_follow_date}}</td>

          <td>
            <badge v-if="row.status=='active'" class="badge-dot mr-4" type="success">
              <i class="bg-success"></i>
              <span class="status">{{row.status}}</span>
            </badge>
            <badge v-else class="badge-dot mr-4" type="danger">
              <i class="bg-danger"></i>
              <span class="status">{{row.status}}</span>
            </badge>
          </td>

          <td class="text-right">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#">{{variables.get('openProfilePage')}}</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination pageCount="3" perPage="10" align="center"></base-pagination>
    </div>
  </div>
</template>
<script>
import { variables } from "../../langs/tr";
export default {
  name: "followers-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      variables,      
    };
  },
};
</script>
<style>
.table-tet{
  border-radius: 6px !important;
}
</style>
